<template>
	<div>
		<div class="report-container">
			<main-header class="i-h" :child="child"></main-header>
			<div class="content">
				<div class="content-nav flex-sb">
					<div class="title col-center">评审列表</div>
					<div class="right col-center">
						<div class="search">
							<el-input style="width: 100%;" placeholder="输入关键字搜索" prefix-icon="el-icon-search"
								v-model="queryForm.key_words">
							</el-input>
						</div>
						<div class="search-btn sub-btn">
							<el-button type="primary" @click="search">搜索</el-button>
						</div>
					</div>
				</div>
				<div class="table">
					<div class="table-inner">
						<el-table stripe :data="tableData" style="width: 100%" v-loading="loading">
							<el-table-column type="index" label="序号" width="60px">
							</el-table-column>
							<el-table-column prop="name" label="项目名称">
							</el-table-column>
							<el-table-column prop="project.title" label="参赛信息">
							</el-table-column>
							<el-table-column prop="school.name" label="项目申报学校">
								<template slot-scope="scope">
									<span v-if="scope.row.is_leaflet_audit == 1">****</span>
									<span v-else>{{scope.row.school.name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="group.name" label="参赛组别">
							</el-table-column>
							<el-table-column prop="achievement.name" label="成果类型">
							</el-table-column>
							<el-table-column prop="teacher_name" label="第一指导教师姓名">
								<template slot-scope="scope">
									<span v-if="scope.row.is_leaflet_audit == 1">***</span>
									<span v-else>{{scope.row.teacher_name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="team_principal_name" label="团队负责人姓名">
								<template slot-scope="scope">
									<span v-if="scope.row.is_leaflet_audit == 1">***</span>
									<span v-else>{{scope.row.team_principal_name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="team_principal_education" label="团队负责人学历">
							</el-table-column>
							<el-table-column prop="end_date" label="校赛评审结果">
								<template slot-scope="scope">
									<span
										:class="[['primary','primary','success'][scope.row.school_audit_status]]">{{['待评审','待评审','已评审'][scope.row.school_audit_status]}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="end_date" label="省赛评审结果">
								<template slot-scope="scope">
									<span
										:class="[['primary','primary','success'][scope.row.province_audit_status]]">{{['待评审','待评审','已评审'][scope.row.province_audit_status]}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="" label="资格审核">
								<template slot-scope="scope">
									<span
										:class="[['primary','success','error','error'][scope.row.apply_audit_status]]">{{['审核中','通过','驳回','省赛驳回'][scope.row.apply_audit_status]}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="score" label="打分" sortable sort-by="scope">
							</el-table-column>
							<el-table-column prop="status" label="操作" width="140px" align="center">
								<template slot-scope="scope">
									<div class="flex-center" style="margin: 0 auto;">
										<div>
											<el-button type="text"
												@click="open(scope.row.item_apply_id, scope.row.audit_status)">查看</el-button>
										</div>
										<div class="line"></div>
										<div><el-button type="text"
												@click="review(scope.row.item_apply_id,scope.row.audit_status == '2')">{{scope.row.audit_status == '2' ? '修改评审' : '评审'}}</el-button>
										</div>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pages">
					<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:page-sizes="[5,10,20,30,50]" :page-size="queryForm.per_page"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
				<div class="pages-small">
					<el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<review-detail @handleReview="review" :isReview="isReview" ref="reviewDetail" v-model="dialogVisible"
			@close="dialogVisible = false"></review-detail>
		<expert-review ref="expertReview" :item_apply_id="item_apply_id" @refresh="getList" v-model="erdialogVisible"
			@close="erdialogVisible = false"></expert-review>
	</div>
</template>

<script>
	import mainHeader from '@/components/main-header/main-header'
	import reviewDetail from './components/review-detail'
	import expertReview from './components/expert-review'
	import {
		reportList
	} from '@/common/api/report.js'
	export default {
		name: '',
		props: {

		},
		components: {
			mainHeader,
			reviewDetail,
			expertReview
		},
		data() {
			return {
				searchkey: '',
				isReview: true,
				queryForm: {
					page: 1,
					per_page: 30,
					key_words: ''
				},
				loading: true,
				total: 0,
				child: [],
				tableData: [],
				dialogVisible: false,
				erdialogVisible: false,
				item_apply_id: ''
			}
		},
		created() {
			this.id = this.$route.query.id
			this.queryForm.audit_project_id = this.id
			this.getList()
		},
		mounted() {
			// 添加面包屑
			this.child = [{
				path: "/index",
				name: "Index",
				title: this.authority === 'expert' ? '参赛作品评审' : '参赛作品提交'
			}, {
				path: "/detail?id=" + this.$route.query.id,
				name: "Detail",
				title: '参赛作品详情'
			}]
		},
		methods: {
			async getList() {
				this.loading = true
				try {
					const {
						data
					} = await reportList(this.queryForm)
					this.tableData = data.data
					this.total = Number(data.meta.pagination.total)
					this.loading = false
					this.dialogVisible = false
				} catch (e) {
					this.loading = false
					//TODO handle the exception
				}

			},
			handleSizeChange(e) {
				this.queryForm.page = 1
				this.queryForm.per_page = e
				this.getList()
			},
			handleCurrentChange(e) {
				console.log(e)
				this.queryForm.page = e
				this.getList()
			},
			search() {
				this.queryForm.page = 1
				this.getList()
			},
			open(id, isReview) {
				if (isReview == 1) {
					this.isReview = false
				} else {
					this.isReview = true
				}
				this.dialogVisible = true
				this.$refs.reviewDetail.init(id)
			},
			review(id, flag) {
				if (flag) {
					this.$refs.expertReview.getDetail(id)
				}
				this.item_apply_id = id
				this.erdialogVisible = true
			}
		}

	}
</script>

<style lang="scss" scoped>
	.report-container {
		width: 100vw;
		height: 100vh;
		background-color: #F7F7F7;
		display: flex;
		flex-direction: column;

		.i-h {
			flex-shrink: 0;
		}

		.content {
			flex-grow: 1;
			height: 0;
			margin: 0.625rem;
			border-radius: 0.375rem;
			background-color: white;
			display: flex;
			flex-direction: column;

			.content-nav {
				padding: 1.25rem;
				border-bottom: 1px solid #E7EBF0;
				flex-shrink: 0;

				.title {
					font-size: 1.5rem;
					font-weight: bold;
					position: relative;
					padding-left: 1.5rem;
				}

				.title::after {
					content: "";
					display: block;
					width: 0.25rem;
					height: 1rem;
					position: absolute;
					background-color: #4389E0;
					left: 0.625rem;
					top: 50%;
					margin-top: -8px;
				}

				.right {
					.search {
						width: 20rem;
						padding: 0 4.375rem;
					}

					.search-btn {
						padding: 0 0.625rem;
					}
				}
			}

			.table {
				height: 0;
				flex-grow: 1;
				overflow-y: auto;
				padding: 1.875rem 2.5rem;

				.primary {
					display: inline-block;
					background: #F0F7FF;
					padding: 0.375rem 0.875rem;
					color: #4389E0;
					font-size: 0.875rem;
					border-radius: 0.375rem;
				}

				.success {
					display: inline-block;
					padding: 0.375rem 0.875rem;
					background: #E8FAEB;
					color: #59DB69;
					font-size: 0.875rem;
					border-radius: 0.375rem;
				}

				.line {
					height: 14px;
					width: 1px;
					margin: 0 0.625rem;
					background-color: #D5D5D5;
				}

				::v-deep .el-table__header tr,
				::v-deep .el-table__header th {
					background-color: #F4F4F4;
				}

				::v-deep .el-table .el-table__header td.el-table__cell,
				::v-deep .el-table .el-table__header th.el-table__cell.is-leaf {
					border-bottom: 0 none;
				}
			}

			.pages {
				padding: 2.5rem;
				display: flex;
				justify-content: flex-end;
			}

			.pages-small {
				display: none;
			}
		}
	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 923px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {}

	@media screen and (max-width: 922px) {
		.report-container {
			.content {
				.content-nav {
					display: block;

					.title {
						font-size: 1.125rem;
					}

					.right {
						.search {
							padding: 1.25rem 0 0;
							width: 100%;

							.el-input {
								width: auto;
								flex-grow: 1;

								::v-deep {
									.el-input {
										width: 100%;
									}
								}
							}
						}

						.sub-btn {
							padding: 1.25rem 0 0 1.25rem;
						}
					}
				}

				.group {
					flex-wrap: wrap;

					.item {
						width: 100%;
						margin: 0.625rem 0 !important;
					}
				}

				.pages {
					display: none;
				}

				.pages-small {
					display: block;
					padding: 1.25rem;

					::v-deep {
						.el-pagination {
							display: flex;
							justify-content: center;
							transform: scale(1.2);
						}
					}
				}

				.table {
					padding: 1.25rem;
					overflow-x: auto;

					.table-inner {
						width: 70rem;
					}
				}
			}

		}

		::v-deep {
			.el-dialog__body {}

			.el-dialog {
				width: 100% !important;
				margin-top: 0 !important;
				border-radius: 0 !important;
			}
		}
	}
</style>